import {useSyncExternalStore} from 'react';

import {createBrowserPhone} from '../utils/createBrowserPhone';

/** One softphone per tab, shared by the top-bar indicator and the Call dialog (a portal). */
const browserPhone = createBrowserPhone();

/**
 * The tab's browser softphone: what it can do right now (`state`) and the actions on it. The
 * top-bar indicator starts and stops it (`useBrowserPhoneLifecycle`); everything else only reads
 * and acts here.
 */
export function useBrowserPhone() {
  const state = useSyncExternalStore(browserPhone.subscribe, browserPhone.getState);

  return {state, phone: browserPhone};
}
